import { useMediaQuery } from '@abyss/web/hooks/useMediaQuery';
import { Accordion } from '@abyss/web/ui/Accordion';
import { Drawer } from '@abyss/web/ui/Drawer';
import { Heading } from '@abyss/web/ui/Heading';
import { Text } from '@abyss/web/ui/Text';
import { find } from 'lodash';
import { useTranslation } from 'react-i18next';

import { useLagoon } from '../../../../hooks/useLagoon';
import { AreaOfExpertiseDetails } from '../../../../models/ProviderDetails';
import { capitalizeEachWord } from '../../../../utils/providerNames.utils';
import { ConstantsLagoon } from '../../../ConstantsLagoon';
import {
  phoneOnly,
  recentActivityDrawerDesktop,
  recentActivityDrawerMobile,
} from '../../../ConstantsStyles';
import { CollapseCardHeaderStyle } from '../About.styled';

type Props = {
  areaOfExpertiseDetails?: AreaOfExpertiseDetails[];
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
};

export const AoeDrawer = ({
  areaOfExpertiseDetails,
  isOpen,
  setIsOpen,
}: Props) => {
  const { t } = useTranslation();
  const mobileScreen = useMediaQuery(phoneOnly);
  const lagoonData = useLagoon('ui-messaging')();
  const aoeDescriptionData = find(lagoonData, {
    key: ConstantsLagoon.UI_MESSAGING.AOE_DESCRIPTION_DRAWER_SUBTITLE,
  });

  return (
    <Drawer
      css={
        mobileScreen ? recentActivityDrawerMobile : recentActivityDrawerDesktop
      }
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      position={mobileScreen ? 'bottom' : 'right'}
      size={mobileScreen ? window.innerHeight - 104 : 408}
      title={
        <Heading
          color="$black"
          data-auto-testid="aoe-drawer-heading"
          data-testid="aoe-drawer-heading"
          offset={3}
        >
          {t('PROVIDER_DETAILS.ABOUT_TAB.DETAILS_SECTION.AREAS_OF_EXPERTISE')}
        </Heading>
      }
    >
      <Drawer.Section>
        <Text
          color="#4B4D4F"
          css={{
            'abyss-text-root': { paddingBottom: '16px', display: 'block' },
          }}
          size={16}
        >
          {aoeDescriptionData?.message}
        </Text>
        <Accordion
          css={CollapseCardHeaderStyle() as any}
          defaultValue={`${areaOfExpertiseDetails?.[0]?.name}-0`}
          isCollapsible
        >
          {areaOfExpertiseDetails &&
            areaOfExpertiseDetails?.map((item, index) => (
              <Accordion.Item
                css={{
                  'abyss-accordion-item': { borderBottom: '1px solid #CBCCCD' },
                }}
                key={`${item.name}-${index}`}
                value={`${item.name}-${index}`}
              >
                <Accordion.Trigger
                  css={{
                    'abyss-accordion-trigger': {
                      padding: '12px 0',
                    },
                  }}
                >
                  <Accordion.Header>
                    {capitalizeEachWord(item.name)}
                  </Accordion.Header>
                </Accordion.Trigger>
                <Accordion.Content>
                  <div style={{ paddingBottom: '16px' }}>
                    <Text color="#4B4D4F" size={16}>
                      {item?.description}
                    </Text>
                  </div>
                </Accordion.Content>
              </Accordion.Item>
            ))}
        </Accordion>
      </Drawer.Section>
    </Drawer>
  );
};
